import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslator } from 'tradera-lang';
import Tags from '../tags/tags';
import { fetchTrendingBrandsIfNeeded } from 'tradera-state/views/start-page/actions';
import { fetchPersonalisedBrandsIfNeeded } from 'tradera-state/personalisation/actions';
import GtmService from 'static/script/app/ui/google-tagmanager-service';

const PersonalisedBrandsTags = ({ scroll }) => {
    const { t } = useTranslator();
    const dispatch = useDispatch();
    const showFallback = useShowPersonalisedBrandsFallback();

    const tags = useSelector(state =>
        showFallback
            ? state.views.startPage.trendingBrands.items
            : state.personalisation.brands.items
    );

    useEffect(() => {
        dispatch(
            showFallback
                ? fetchTrendingBrandsIfNeeded()
                : fetchPersonalisedBrandsIfNeeded()
        );
    }, [dispatch, showFallback]);

    const isLoading = useIsPersonalisedBrandsTagsLoading();
    useEffect(() => {
        if (!isLoading) {
            GtmService.trackAction(
                showFallback
                    ? 'Personalised Brands fallback showed'
                    : 'Personalised Brands showed',
                'Navigation'
            );
        }
    }, [showFallback, isLoading]);

    if (isLoading) {
        // Approximated height of component when loaded
        return <div style={{ height: 140 }} />;
    }

    return (
        <>
            <h3 className="mb-2 px-3 px-md-2 text-styled">
                {showFallback
                    ? t('trendingTags_brands')
                    : t('personalised_suggestions_brands')}
            </h3>
            <Tags
                gaCategory={
                    showFallback
                        ? 'Personalised Brands fallback'
                        : 'Personalised Brands'
                }
                tags={tags}
                scroll={scroll}
            />
        </>
    );
};

export const useShowPersonalisedBrandsFallback = () =>
    useSelector(state => state.personalisation.brands.status == 'HAS_NO_DATA');

export const useIsPersonalisedBrandsTagsLoading = () => {
    const status = useSelector(state => state.personalisation.brands.status);
    const fallbackStatus = useSelector(
        state => state.views.startPage.trendingBrands.status
    );

    if (status === 'HAS_DATA') return false;
    if (status === 'HAS_NO_DATA') {
        if (fallbackStatus === 'HAS_DATA' || fallbackStatus === 'HAS_NO_DATA')
            return false;
        return true;
    }
    return true;
};

PersonalisedBrandsTags.defaultProps = {
    scroll: false
};

PersonalisedBrandsTags.propTypes = {
    scroll: PropTypes.bool
};

export default PersonalisedBrandsTags;
